export function patientIdChange(prevProps) {
    if (prevProps.match.params.patientId !== this.props.match.params.patientId) {
        this.setState({ patientId: this.props.match.params.patientId }, () =>
            this.componentDidMount(),
        );
    }
}
